import { createFileRoute, redirect } from "@tanstack/react-router";

/** Superseded by the console space level. */
export const Route = createFileRoute("/dashboard/space")({
  beforeLoad: () => {
    throw redirect({ to: "/console/spaces" });
  },
});
